import script from "./DownloadFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./DownloadFile.vue?vue&type=script&lang=ts&setup=true"

import "./DownloadFile.vue?vue&type=style&index=0&id=4a0883d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a0883d4"]])

export default __exports__